import React, { useState, useEffect } from 'react';
import { PLAYER } from '../data';
import iconMap from '../iconMap';
import { RESOURCES } from '../content/common';
import { Plus } from 'lucide-react';

function HUD() {
  const [resources, setResources] = useState(PLAYER.resources);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentResources = PLAYER.resources;
      const hasChanged = Object.keys(RESOURCES).some(
        key => resources[key] !== currentResources[key]
      );

      if (hasChanged) {
        setResources({...currentResources});
      }
    }, 100);

    return () => clearInterval(interval);
  }, [resources]);

  const getColorClasses = (color) => ({
    icon: `text-${color}-400`,
    text: `text-${color}-200`
  });

  return (
    <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-r from-gray-900/90 to-gray-800/90 backdrop-blur-sm border-b border-gray-700/50">
      <div className="flex justify-around items-center h-full px-4 w-full">
        {Object.entries(RESOURCES).map(([key, config]) => {
          const colors = getColorClasses(config.color);
          return (
            <div
              key={key}
              className="flex items-center relative flex-1 mx-2 min-w-[120px]"
            >
              <div className="flex items-center justify-end bg-gray-800 px-4 py-0.5 rounded-lg w-full pl-12">
                <span className={`font-['VT323'] ${colors.text} text-right text-xl`}>
                  {resources[key].toLocaleString()}
                  {config.maxValue ? `/${config.maxValue}` : ''}
                </span>
                <button className="ml-1 hover:bg-white/10 rounded-full p-1">
                  {React.createElement(Plus, {
                    size: 20,
                    className: colors.text
                  })}
                </button>
              </div>
              <div className="absolute left-0 -translate-x-1">
                {React.createElement(iconMap[RESOURCES[key].id], {
                  size: 40,
                  className: colors.icon
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default HUD;
